import { produce } from 'immer'
import { State } from '../typings'
import { ServiceLocation } from '@user/store/entityLocations'

export type SelectServiceLocationAction = {
  type: 'selectServiceLocation'
  payload: ServiceLocation
}

type SelectServiceLocationActionCreator = (
  payload: SelectServiceLocationAction['payload'],
) => SelectServiceLocationAction

export const selectServiceLocation = produce<
  State,
  [SelectServiceLocationAction['payload']]
>((draft, payload) => {
  const { id } = payload

  if (draft.selectedServiceLocations.has(id)) {
    draft.selectedServiceLocations.delete(id)
  } else {
    draft.selectedServiceLocations.set(id, payload)
  }
})

export const selectServiceLocationActionCreator: SelectServiceLocationActionCreator =
  (payload) => ({
    type: 'selectServiceLocation',
    payload,
  })
